import { useCallback, useEffect, useState } from 'react'
import { getClosedCaptions } from '../../../actions/contentActions'
import { decodeHTML, handleContentError } from '../utils'
import { useGetClosedCaptionsDataProps } from '../types'

const useGetClosedCaptionsData = ({
  isVisible,
}: useGetClosedCaptionsDataProps) => {
  const [title, setTitle] = useState('')
  const [text, setText] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchClosedCaptions = useCallback(() => {
    setLoading(true)
    getClosedCaptions()
      .then((resp) => {
        const content = resp?.collections?.[0]
        const contentText = content?.content?.[0]?.text ?? ''

        setTitle(decodeHTML(content?.title))
        setText(decodeHTML(contentText))
      })
      .catch(({ error, url }) => {
        setTitle('Closed Captioning')
        setText(
          "We weren't able to load the Closed Captioning information at this time. You can access it on the web at https://www.pbs.org/cc-info/"
        )

        handleContentError('getClosedCaptionsData', error, url)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    if (isVisible) {
      fetchClosedCaptions()
    }
  }, [isVisible, fetchClosedCaptions])

  return {
    title,
    text,
    loading,
  }
}

export default useGetClosedCaptionsData
